import React, { useState, useEffect, memo } from "react";
import { Carousel, Button, Container, Row, Col } from "react-bootstrap";
import { ArrowLeft, ArrowRight, ArrowLeftCircle } from "react-bootstrap-icons";

// --- RESİM IMPORTLARI ---
import foto1 from "../assets/uygulamafoto/foto1.png";
import foto2 from "../assets/uygulamafoto/foto2.png";
import foto4 from "../assets/uygulamafoto/foto4.png";
import foto5 from "../assets/uygulamafoto/foto5.png";
import foto7 from "../assets/uygulamafoto/foto7.png";
import foto8 from "../assets/uygulamafoto/foto8.png";
import foto9 from "../assets/uygulamafoto/foto9.png";
import foto10 from "../assets/uygulamafoto/foto10.png";
import foto11 from "../assets/uygulamafoto/foto11.png";
import foto12 from "../assets/uygulamafoto/foto12.png";
import foto13 from "../assets/uygulamafoto/foto13.png";
import foto14 from "../assets/uygulamafoto/foto14.png";
import foto15 from "../assets/uygulamafoto/foto15.png";
import foto16 from "../assets/uygulamafoto/foto16.png";

import "./Projeler.css";

// --- SABİT VERİLER ---
const MIRASIM_VERILERI = [

  // ── MİRAS / TEREKE BÖLÜMÜ ─────────────────────────────────────────────────
  {
    resim: foto1,
    baslik: "1. Ana Ekran — Genel Bakış",
    aciklama: "MİRASIM uygulaması; Tereke Yönetimi, Miras Paylaştırma, Vasiyet Hazırlama, Saklı Pay Hesabı ve Arabuluculuk olmak üzere beş temel modülden oluşmaktadır. Kullanıcı, işlem yapmadan önce ilgili modülü seçerek süreci başlatır."
  },
  {
    resim: foto2,
    baslik: "2. Tereke Girişi",
    aciklama: "Tereke Yönetimi modülü, mirasın işleme alınabilmesi için zorunlu ilk adımı oluşturmaktadır. Bu ekranda muris bilgileri sisteme kaydedilerek tereke kaydı oluşturulur; akabinde taşınır ve taşınmaz varlıkların girişine geçilir."
  },
  {
    resim: foto4,
    baslik: "3. Tereke Özeti — Varlık Takibi",
    aciklama: "Sisteme eklenen tüm taşınır ve taşınmaz varlıklar bu ekranda kategorik olarak listelenir. Kullanıcı, mevcut varlıkları görüntüleyebilir, güncelleyebilir ya da tereke dışına çıkarabilir. Toplam tereke değeri anlık olarak hesaplanarak özet bilgi sunulur."
  },
  {
    resim: foto5,
    baslik: "4. Mirasçılık Belgesi Taraması",
    aciklama: "Miras Paylaştırma modülünde yer alan bu işlev sayesinde, noterden düzenlenmiş Mirasçılık Belgesi yapay zeka destekli optik karakter tanıma (OCR) teknolojisi ile taranarak mirasçı bilgileri otomatik olarak sisteme aktarılır. Bu işlem, manuel veri girişini ortadan kaldırarak hata riskini en aza indirir."
  },
  {
    resim: foto7,
    baslik: "5. Mirasçı Yönetimi",
    aciklama: "Mirasçılar ekranında, belge taraması yoluyla veya manuel yöntemle mirasçı eklenebilir, düzenlenebilir ya da listeden çıkarılabilir. Kimlik belgesi tarama özelliği ile üçüncü şahıslara ait kişisel veriler yalnızca geçici olarak işlenmekte; platform bünyesinde kalıcı biçimde saklanmamaktadır."
  },
  {
    resim: foto8,
    baslik: "6. Saklı Pay Hesaplama Modülü",
    aciklama: "Bu modülde, yasal ve vasiyetname mirasçılarına ait saklı pay oranları Türk Medeni Kanunu hükümleri çerçevesinde otomatik hesaplanır. Kullanıcı tasarruf yapılacak tutarı girerek saklı pay ihlali bulunup bulunmadığını anında sorgulayabilir."
  },
  {
    resim: foto14,
    baslik: "7. Saklı Pay İhlali Uyarısı",
    aciklama: "Oluşturulan paylaşım senaryolarından herhangi birinin yasal mirasçıların saklı payını ihlal etmesi durumunda söz konusu senaryo kırmızı renkle işaretlenerek kullanıcı uyarılır. Ekranda ayrıca ihlal miktarı sayısal olarak gösterilir; buna karşın kullanıcı, bilinçli kararla ilgili senaryoyu seçme yetkisini korur."
  },
  {
    resim: foto9,
    baslik: "8. Miras Paylaştırma Senaryoları",
    aciklama: "Mirasçıların belirlenmesinin ardından uygulama, matematiksel dağıtım algoritmalarını kullanarak olası paylaşım senaryolarını oluşturur. Kullanıcı dilerse dağıtımı manuel olarak yapılandırabilir ya da 'Otomatik Dağıt' seçeneği ile en uygun senaryoya ulaşabilir. Belirlenen senaryolar PDF formatında dışa aktarılabilir."
  },
  {
    resim: foto15,
    baslik: "9. Belge Oluşturma — Vasiyetname / Miras Paylaşım Sözleşmesi",
    aciklama: "Paylaşım senaryosunun onaylanmasının ardından sürecin başlangıç modülüne göre farklı belge oluşturulur: Vasiyet modülü üzerinden gelinmişse Vasiyetname, Miras Paylaştırma modülü üzerinden gelinmişse Miras Paylaşım Sözleşmesi hazırlanır. Her iki belge de Türk Medeni Kanunu hükümlerine uygun olarak yapılandırılır."
  },
  {
    resim: foto16,
    baslik: "10. Hukukî Uyumluluk ve Belge Bütünlüğü",
    aciklama: "Uygulama tarafından üretilen tüm belgeler; Türk Medeni Kanunu ve ilgili yönetmeliklere uygunluk denetiminden geçirilmektedir. Belge içerikleri, terminoloji ve yapısal format bakımından tutarlı bir hukukî dil standardına göre oluşturulur."
  },

  // ── ARABULUCULUK BÖLÜMÜ ───────────────────────────────────────────────────
  {
    resim: foto10,
    baslik: "11. Arabuluculuk Başvurusu",
    aciklama: "Arabuluculuk modülüne ilk girişte arabulucuya özgü kişiselleştirme ayarları yapılandırılır. Akabinde başvuru formu ya elle doldurulabilir ya da yapay zeka destekli form tarama işlevi aracılığıyla bilgiler otomatik olarak sisteme aktarılabilir. Eksik alanlar geçici olarak kaydedilerek sürece sonraki oturumda devam edilebilir."
  },
  {
    resim: foto11,
    baslik: "12. Davet Mektupları",
    aciklama: "Başvurunun tamamlanmasının ardından uygulama, her bir taraf için ayrı ayrı kişiselleştirilmiş davet mektubu oluşturur. Belgeler, yasal gerekliliklere uygun biçimde hazırlanarak PDF formatında taraflara iletilmek üzere çıktıya alınır."
  },
  {
    resim: foto12,
    baslik: "13. Anlaşmama Tutanağı",
    aciklama: "Toplantı sürecinde taraflar arasında uzlaşıya varılamaması hâlinde arabulucu, toplantı yöntemini (yüz yüze / uzaktan) seçerek tek adımda resmî Anlaşmama Tutanağı oluşturabilir. Belge, hukuki geçerlilik kapsamında otomatik biçimde yapılandırılır."
  },
  {
    resim: foto13,
    baslik: "14. Anlaşma Tutanağı",
    aciklama: "Uzlaşı sağlanması durumunda belirlenen anlaşma koşulları sisteme girilir; 'Yapay Zeka ile Hukukileştir' işlevi, bu koşulları Türk Hukuku'na uygun resmî tutanak diline dönüştürür. Miras Paylaşım Sözleşmesi'nin dahil edilmesi talep edildiğinde, iki belge tek bir tutanak altında birleştirilir."
  },
];



const PROJE_LISTESI = [
  {
    id: 1,
    ad: "MİRASIM",
    ozet: "Miras paylaşımının güvenli, hızlı ve teknolojik yolu. Mobil uygulama tanıtımı ve kullanım kılavuzu.",
    kapakResmi: foto1,
    kategori: "Mobil Uygulama",
    veri: MIRASIM_VERILERI
  }
];

const Projeler = () => {
  const [seciliProje, setSeciliProje] = useState(null);
  const [aktifSlaytIndex, setAktifSlaytIndex] = useState(0);

  // Proje seçilince sayfanın en üstüne kaydır
  useEffect(() => {
    if (seciliProje) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [seciliProje]);

  const handleSelect = (selectedIndex) => {
    setAktifSlaytIndex(selectedIndex);
  };

  const projeyeGit = (proje) => {
    setSeciliProje(proje);
    setAktifSlaytIndex(0);
  };

  const listeyeDon = () => {
    setSeciliProje(null);
  };

  // --- DURUM 1: LİSTE GÖRÜNÜMÜ ---
  if (!seciliProje) {
    return (
      <div className="projects-page">
        {/* HERO SECTION */}
        <div className="projects-hero">
          <div className="projects-hero-pattern"></div>
          <Container style={{ position: 'relative', zIndex: 2 }}>
            <h1 className="projects-title display-3">Projelerimiz</h1>
            <p className="projects-subtitle">
              Geleceği şekillendiren teknolojik çözümlerimizi ve yenilikçi uygulamalarımızı keşfedin.
            </p>
          </Container>
        </div>

        {/* PROJECTS GRID */}
        <Container className="projects-grid-section">
          <Row className="justify-content-center g-4">
            {PROJE_LISTESI.map((proje) => (
              <Col key={proje.id} xs={12} md={6} lg={4}>
                <div
                  className="modern-project-card"
                  onClick={() => projeyeGit(proje)}
                >
                  <div className="card-img-container">
                    <img src={proje.kapakResmi} alt={proje.ad} loading="lazy" />
                    <div className="card-overlay"></div>
                    <span className="project-meta-badge">{proje.kategori}</span>
                  </div>

                  <div className="card-content">
                    <h3 className="project-name">{proje.ad}</h3>
                    <p className="project-summary">{proje.ozet}</p>
                    <button className="view-project-btn">
                      İncele &rarr;
                    </button>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    );
  }

  // --- DURUM 2: DETAY GÖRÜNÜMÜ ---
  const currentSlayt = seciliProje.veri[aktifSlaytIndex];

  return (
    <div className="project-detail-wrapper">
      <Container fluid="lg">

        {/* Navigasyon */}
        <div className="nav-back-container">
          <Button
            className="back-btn shadow-sm"
            onClick={listeyeDon}
          >
            <ArrowLeftCircle className="me-2" size={20} />
            Tüm Projeler
          </Button>
        </div>

        {/* Ana İçerik Kartı */}
        <div className="detail-main-card">
          <Row className="g-0">

            {/* SOL: Telefon / Görsel Alanı */}
            <Col lg={5} className="phone-mockup-container">
              <div className="phone-mockup">
                <Carousel
                  fade={false}
                  interval={null}
                  indicators={false}
                  controls={true}
                  activeIndex={aktifSlaytIndex}
                  onSelect={handleSelect}
                  touch={true}
                >
                  {seciliProje.veri.map((slayt, index) => (
                    <Carousel.Item key={index}>
                      <img
                        className="d-block w-100 carousel-img"
                        src={slayt.resim}
                        alt={slayt.baslik}
                        loading={index === 0 ? "eager" : "lazy"}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
            </Col>

            {/* SAĞ: İçerik Alanı */}
            <Col lg={7} className="detail-text-container">
              <div className="step-indicator">
                ADIM {aktifSlaytIndex + 1} / {seciliProje.veri.length}
              </div>

              <h2 className="slide-title display-6">
                {currentSlayt.baslik}
              </h2>

              <p className="slide-desc">
                {currentSlayt.aciklama}
              </p>

              <div className="nav-controls">
                <Button
                  variant="outline-dark"
                  className="rounded-pill px-4"
                  disabled={aktifSlaytIndex === 0}
                  onClick={() => setAktifSlaytIndex(prev => prev - 1)}
                >
                  <ArrowLeft className="me-2" /> Önceki
                </Button>
                <Button
                  variant="dark"
                  className="rounded-pill px-4"
                  disabled={aktifSlaytIndex === seciliProje.veri.length - 1}
                  onClick={() => setAktifSlaytIndex(prev => prev + 1)}
                >
                  Sonraki <ArrowRight className="ms-2" />
                </Button>
              </div>
            </Col>

          </Row>
        </div>
      </Container>
    </div>
  );
};

export default memo(Projeler);
